import React, { useEffect, useState } from "react";
import { Text, StyleSheet, View, LayoutAnimation } from "react-native";

import ShowMoreItems from "../../common/ShowMoreItems";
import { hasItems } from "../../../../helpers/utils";
import TreeHeaderItem from "./TreeHeaderItem";
import AddElement from "./AddElement";

const MAX_NUM_ELEMENTS = 10;

let TreeNode = ({
  item,
  level = 1,
  index,
  openCreateElementDialog = () => {},
}) => {
  const [hasMoreItems, setHasMoreItems] = useState(level > 1);
  const [initialNumberToRender] = useState(MAX_NUM_ELEMENTS);
  const [itemsList, setItemsList] = useState([]);
  const [message, setMessage] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(item.isCollapsed);

  const hasChildren = hasItems(item.children);
  const showAddElement =
    hasChildren && item.name && item.name.indexOf("Meetings") < 0;

  useEffect(() => {
    const children = item.children;
    if (!children) return;

    if (hasMoreItems && children.length > initialNumberToRender) {
      setItemsList(children.slice(0, initialNumberToRender));
      setHasMoreItems(true);
      setMessage(
        children.length - initialNumberToRender + ` more Elements ${item.name}`,
      );
    } else {
      setItemsList([...children]);
      setHasMoreItems(false);
    }
  }, [item.children]);

  // ------------------------------------- METHODS -------------------------------------
  const showMore = () => {
    const { children } = item;
    setItemsList(children.slice(0));
    setHasMoreItems(false);
  };

  const toggleExpand = () => {
    if (!hasItems(item.children)) return;

    setIsCollapsed((prevIsCollapsed) => {
      LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
      setIsCollapsed(!prevIsCollapsed);
      item.isCollapsed = !item.isCollapsed;
    });
  };

  return (
    <View style={[styles.container, level == 1 && styles.set]}>
      <TreeHeaderItem
        item={{ ...item }}
        index={index}
        onPress={toggleExpand}
        isCollapsed={isCollapsed}
        level={level}
        hasChildren={hasChildren}
      />

      {hasItems(itemsList) && !isCollapsed ? (
        <View style={styles.listContainer}>
          {itemsList.map((currentItem) => (
            <TreeNode
              item={currentItem}
              key={`${item.item_id}_${currentItem.item_id}`}
              level={level + 1}
              openCreateElementDialog={openCreateElementDialog}
            />
          ))}
          <ShowMoreItems
            onPress={showMore}
            message={message}
            hasMoreItems={hasMoreItems}
          />

          {showAddElement ? (
            <AddElement
              title={`Add Element to ${item.name}`}
              onPress={() => openCreateElementDialog(item.item_id)}
              style={{
                marginLeft: level * 25 || 25,
                backgroundColor: "#F3F2F1",
                marginBottom: 10,
                paddingHorizontal: 16,
                marginRight: "auto",
                width: "auto",
              }}
            />
          ) : null}
        </View>
      ) : null}
    </View>
  );
};

export default TreeNode;

const styles = StyleSheet.create({
  container: {
    position: "relative",
    backgroundColor: "#FFF",
    width: "100%",
  },
  set: {
    marginBottom: 8,
    borderRadius: 4,
    shadowColor: "#000",
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 5,
    paddingBottom: 20,
  },
  moreWrapper: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: 20,
    height: 50,
  },
  listContainer: {
    backgroundColor: "#FFF",
  },
});
